/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentPreviewFeedbackReason =
    (typeof DocumentPreviewFeedbackReason)[keyof typeof DocumentPreviewFeedbackReason];

export const DocumentPreviewFeedbackReason = {
    VisualMismatch: 'VisualMismatch',
    MissingContent: 'MissingContent',
    Unreadable: 'Unreadable',
    Other: 'Other',
} as const;
